import { render, staticRenderFns } from "./com-dialog.vue?vue&type=template&id=b4f321d0&scoped=true&"
import script from "./com-dialog.vue?vue&type=script&lang=js&"
export * from "./com-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f321d0",
  null
  
)

export default component.exports